import {
  LinksTransferRequestAdaParams,
  linksYoroiModuleMaker,
} from '@yoroi/links'
import {Links} from '@yoroi/types'
import {PartnerInfoType} from 'common/partner-info'

export const requestAda = ({
  scheme,
  targets,
  memo,
  partnerInfo,
}: {
  scheme: Links.YoroiUriConfig['scheme']
  targets: LinksTransferRequestAdaParams['targets']
  memo?: LinksTransferRequestAdaParams['memo']
  partnerInfo: PartnerInfoType
}) => {
  try {
    const {transfer} = linksYoroiModuleMaker(scheme)

    const link = transfer.request.ada({
      targets,
      ...(memo && memo !== '' ? {memo} : {}),
      ...partnerInfo,
    })

    return {link, error: null}
  } catch (e: any) {
    return {error: e.message, link: null}
  }
}
